import * as React from 'react';
// components
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import ErrorAlert from '../../components/ErrorAlert';
import Field from '../../components/Field';
import { FileInput } from './FileInput';
import { usePdfFile } from '../hooks/usePdfFile';
// helpers
import { errorHandlers } from '../helpers/errorHandlers';
// types
import type { CreatorProps } from '../types';

export const PdfResultCreator = (props: CreatorProps) => {
  // @ts-ignore
  const { dispatcher, schema, error, value, visited, opts } = props;

  const { getError, setError } = errorHandlers({
    dispatcher,
    error,
    schema,
    value,
    visited,
  });
  const { className, errorText } = getError();

  const dispatcherPDF = dispatcher.pullValue(`${schema.id}_file`);

  const onChangeSuccess = () => {
    opts.formActions.actionScrollToField(`${schema.id}_file`, true);
  };

  // Получение файла
  const { pdf, isLoading, getPdfFile } = usePdfFile({
    ...props,
    setError,
  });

  return (
    <Field {...props.schema} status={className} title={''}>
      <div>
        <div className="sig-file">
          <FileInput
            {...props}
            schemaProps={{
              id: `${schema.id}_file`,
              value: dispatcherPDF ?? (pdf ? { inputs: [pdf] } : null),
              title: {
                ru: '',
                en: '',
              },
              disabled: props.schema?.disabled,
              extra: {
                onChangeSuccess,
              },
            }}
          />
        </div>
        {/* @ts-ignore */}
        <Divider />
      </div>

      {!dispatcherPDF ? (
        /* @ts-ignore */
        <Button
          label="Получить файл заявки"
          type="button"
          onClick={getPdfFile}
          disabled={isLoading}
        />
      ) : null}
      <ErrorAlert errorMessage={errorText} />
    </Field>
  );
};
